import { memo } from "react";
import { Box } from "@mui/material";

import Flx from "../../../../../components/layout/Flx";
import Txt from "../../../../../components/typography/Txt";

import {
  PALETTE,
  SHADOW_SM,
  FONT_MONO,
  TimelineMarker,
} from "./_shared";

const LoanTimelineCard = ({ timeline, todayLabel }) => (
  <Box
    sx={{
      background: PALETTE.surface,
      border: `1px solid ${PALETTE.line}`,
      borderRadius: "10px",
      boxShadow: SHADOW_SM,
      px: "28px",
      py: "24px",
      mb: 2,
      // mb: "36px",
    }}
  >
    <Flx ac jb sx={{ alignItems: "baseline", mb: "22px" }}>
      <Txt
        component="h3"
        sx={{
          fontWeight: 700,
          fontSize: 16,
          letterSpacing: "-0.01em",
          m: 0,
          color: PALETTE.ink,
        }}
      >
        Loan timeline
      </Txt>
      <Txt
        component="div"
        sx={{
          fontSize: 11,
          color: PALETTE.ink3,
          fontFamily: FONT_MONO,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
        }}
      >
        TODAY · {todayLabel}
      </Txt>
    </Flx>
    {/* Inset matches the Milestone Progression timeline below so
        both visualizations share the same effective track width.
        30px is the practical minimum given the 110px max-width
        labels — combined with the panel's px:28 padding that gives
        ~3px clearance for a worst-case label. */}
    <Box sx={{ position: "relative", height: 78, mx: "30px" }}>
      <Box
        sx={{
          position: "absolute",
          // 22px label slot + 10px gap + ~5.5px (half of 11px dot) ≈ 38px
          top: "38px",
          left: 0,
          right: 0,
          height: "1px",
          background: PALETTE.line,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: `${timeline.todayPct ?? 0}%`,
            background: PALETTE.accent,
          }}
        />
      </Box>
      {timeline.markers.map((m) => (
        <TimelineMarker
          key={m.key}
          leftPct={m.leftPct}
          label={m.label}
          dateText={m.dateText}
          state={m.state}
        />
      ))}
    </Box>
  </Box>
);

export default memo(LoanTimelineCard);
